module.exports = __webpack_public_path__ + "img/39.64f646dd.gif";